import React from 'react'

import { useHistory, useLocation } from 'react-router-dom'

import { CompatibleRouteProvider } from '@hz-insights/web-components'

// 相对路径引入: 项目 jest modulePaths 为历史遗留 Windows 路径, 绝对引入在 jest 下无法解析
import { rewriteChartNavPath } from '../../utils/chartLang'

const CompatibleRouterProvider: React.FC = ({ children }) => {
  const history = useHistory()
  const { pathname } = useLocation()
  return (
    <CompatibleRouteProvider
      CompatibleRoute={{
        pathname,
        navigate(target, options) {
          // 组件库图表选项注入跳转到裸 /charts/:id, 英文图表页内需补回 en
          history[options?.replace ? 'replace' : 'push'](rewriteChartNavPath(target, pathname))
        }
      }}
    >
      {children}
    </CompatibleRouteProvider>
  )
}

export { CompatibleRouterProvider }
